export default "__VITE_ASSET__taW1_s4t__"